import React, { Component } from 'react'
import { brandStyles, logoNode } from './V2Helpers'
import V2PoweredBy from './V2PoweredBy'
import V2RefreshStrip from './V2RefreshStrip'

class V2AccessCodePage extends Component {
    state = {
        accessCode: "",
        loading: false,
        message: ""
    }

    submit = () => {
        const code = String(this.state.accessCode || "").trim()
        if (!code) {
            this.setState({ message: "Enter the event access code." })
            return
        }

        this.setState({ loading: true, message: "" }, () => {
            this.props.onUnlock(code, (success) => {
                this.setState({
                    loading: false,
                    message: success ? "" : "That code did not unlock this event."
                })
            })
        })
    }

    render() {
        const { client, event } = this.props
        const brand = brandStyles(client, event || {})
        const backgroundStyle = {
            backgroundImage: brand.backgroundUrl ? "url(" + brand.backgroundUrl + ")" : undefined,
            "--v2-primary": brand.primaryColor,
            "--v2-secondary": brand.secondaryColor
        }
        const overlayStyle = { backgroundColor: brand.overlayColor, opacity: brand.overlayOpacity }

        return (
            <div className="v2-public-page v2-buy-page" style={backgroundStyle}>
                <V2RefreshStrip />
                <div className="v2-public-overlay" style={overlayStyle} />
                <main className="v2-buy-complete v2-access-card">
                    {logoNode(client, event || {}, "v2-public-logo")}
                    <h1>Private event</h1>
                    <p>Enter the access code to view this event.</p>
                    <input
                        type="password"
                        placeholder="Access code"
                        value={this.state.accessCode}
                        onChange={(e) => this.setState({ accessCode: e.target.value, message: "" })}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") this.submit()
                        }}
                    />
                    {this.state.message ? <p className="v2-error-message">{this.state.message}</p> : null}
                    <button className="v2-primary-action" disabled={this.state.loading} onClick={this.submit}>
                        {this.state.loading ? "Checking..." : "Unlock event"}
                    </button>
                    <V2PoweredBy />
                </main>
            </div>
        )
    }
}

export default V2AccessCodePage
